import { useContext } from 'react'

import BrandingContext from '../context/BrandingContext'

const useBranding = () => {
  return useContext(BrandingContext)
}

export default useBranding
